(function () {
    window.weissClubLambdaUrl = 'https://0765rhxtv9.execute-api.eu-central-1.amazonaws.com';
}());